<template>
	<div class="patient-view overview">
		<FilterCard v-if="filter"
			:edit="true"
			v-bind:filter="filterData">
		</FilterCard>
		<!-- <ScheduleCard :population="population">
		</ScheduleCard> -->
		<FacesheetCard
			v-if="print"
			:population="population"
			:print="print">
		</FacesheetCard>
	</div>
</template>

<script>
import Cards from './card/components'
import PopulationMixin from './mixin/population'

import FilterCard from '@/module/filter/FilterCard'
import FacesheetCard from './card/facesheet/Facesheet'

export default {
	props: {
		label: {
			type: String
		},
		filter: {
			type: String
		},
		print: {
			type: Object
		}
	},

	mixins: [ PopulationMixin ],

	data() {
		return {

		}
	},

	components: {
		...Cards,
		FilterCard,
		FacesheetCard
	}
}
</script>
